import dayjs from 'dayjs';
import { IPublisher } from 'app/shared/model/publisher.model';

export interface ICustomer {
  id?: string;
  userId?: string | null;
  name?: string | null;
  gender?: string | null;
  birthDate?: dayjs.Dayjs | null;
  age?: number | null;
  phoneNumber?: string | null;
  icNumber?: string | null;
  joinDate?: dayjs.Dayjs | null;
  publisher?: IPublisher | null;
}

export const defaultValue: Readonly<ICustomer> = {};
